module.exports = __webpack_public_path__ + "static/media/zoleWon_25_50.166183d1.png";